import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CallCard from './CallCard';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '350px',
    float: 'right',
    position: '-webkit-sticky',
    position: 'sticky',
    bottom: 30,
    right: 30,
    zIndex: 99999,
    display: 'flex',
    alignItems: 'flex-end',
    alignContent: 'flex-end',
    flexFlow: 'column-reverse wrap',
    ' & > div:not(:last-child)': {
      marginTop: theme.spacing(1),
    },
    ' & > div': {
      marginLeft: theme.spacing(1),
    },
  },
}));

const IncomingCall = ({ voipData, onClose }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {voipData?.map((vd, i) => (
        <CallCard
          voipData={vd}
          key={`${vd.callUID}-${i}`}
          onClose={onClose}
          show={voipData?.length === i + 1}
        />
      ))}
    </div>
  );
};

export default React.memo(IncomingCall);
